// AUTO-GENERATED by scripts/sync-d1-festival-routes.mjs; do not edit.
// Source: business/ishvaram/data/governance/d1_festival_routes.json

export const D1_SERVED_HI_SLUGS = [
  "bhai-dooj-2026",
  "bhai-dooj-2027",
  "chhath-puja-2026",
  "chhath-puja-2027",
  "dhanteras-2026",
  "dhanteras-2027",
  "diwali-2026",
  "diwali-2027",
  "dussehra-2026",
  "dussehra-2027",
  "ganesh-chaturthi-2026",
  "ganesh-chaturthi-2027",
  "govardhan-puja-2026",
  "govardhan-puja-2027",
  "holi-2027",
  "janmashtami-2026",
  "janmashtami-2027",
  "karwa-chauth-2026",
  "karwa-chauth-2027",
  "navratri-2026",
  "navratri-2027",
  "raksha-bandhan-2026",
  "raksha-bandhan-2027"
] as const;
